// Locale strings of report 2.7 (accounts-inventory), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "تقرير جرد الحسابات",
  title: "تقرير جرد الحسابات",
  reportDate: "تاريخ الجرد",
  yearStart: "بداية السنة المالية",
  sector: "القطاع",
  allSectors: "كل القطاعات",
  customParent: "حساب أب مخصص",
  customParentLabel: "الحساب الأب",
  subsector: "القطاع الفرعي",
  allSubsectors: "كل القطاعات الفرعية",
  status: "حالة الحساب",
  allStatuses: "كل الحالات",
  balanceFilter: "الرصيد",
  balanceAll: "كل الأرصدة",
  balancePositive: "رصيد موجب",
  balanceNegative: "رصيد سالب",
  balanceZero: "رصيد صفري",
  balanceAbnormal: "رصيد غير طبيعي",
  balanceRange: "نطاق محدد",
  balanceFrom: "الرصيد من",
  balanceTo: "الرصيد إلى",
  lastFrom: "آخر حركة من",
  lastTo: "آخر حركة إلى",
  daysFrom: "عدد الأيام من",
  daysTo: "عدد الأيام إلى",
  notMovedDays: "لم يتحرك منذ (يوم)",
  partyType: "نوع الطرف",
  allPartyTypes: "كل الأطراف",
  noParty: "بلا طرف",
  partySearch: "اسم الطرف / الهاتف",
  province: "المحافظة",
  allProvinces: "كل المحافظات",
  partyStatus: "حالة الطرف",
  allPartyStatuses: "كل الحالات",
  advanced: "حدود التصنيف",
  activeDays: "نشط حتى (يوم)",
  semiDays: "شبه نشط حتى (يوم)",
  dormantDays: "راكد حتى (يوم)",
  largeBalance: "حد الرصيد الكبير",
  thresholdsHint: "نشط ≤ 30، شبه نشط 31-60، راكد 61-90، راكد جداً > 90 (افتراضياً)",
  viewDetailed: "الجدول التفصيلي",
  viewSummary: "ملخص القطاعات",
  viewAlerts: "التنبيهات",
  viewDeleted: "أطراف محذوفة",
  accountsCount: "عدد الحسابات",
  totalAccounts: "عدد الحسابات",
  active: "نشط",
  semiActive: "شبه نشط",
  dormant: "راكد",
  veryDormant: "راكد جداً",
  unused: "غير مستخدم",
  closed: "مُغلق",
  zeroBalance: "صفر رصيد",
  debitBalances: "إجمالي الأرصدة المدينة",
  creditBalances: "إجمالي الأرصدة الدائنة",
  net: "صافي الرصيد",
  abnormal: "أرصدة غير طبيعية",
  needsReview: "تحتاج مراجعة",
  closable: "يمكن إغلاقها",
  colIndex: "#",
  colCode: "رمز الحساب",
  colName: "اسم الحساب",
  colLevel: "المستوى",
  colParentCode: "رمز الأب",
  colParentName: "اسم الأب",
  colType: "نوع الحساب",
  colNature: "طبيعة الرصيد",
  colIsActive: "مفعّل",
  colIsLeaf: "طرفي",
  colPartyId: "رقم الطرف",
  colParty: "الطرف",
  colPartyType: "نوع الطرف",
  colPartyPhone: "الهاتف",
  colPartyStatus: "حالة الطرف",
  colPartyCreatedAt: "تاريخ إنشاء الطرف",
  colLastDate: "آخر حركة",
  colLastType: "نوع آخر حركة",
  colLastAmount: "مبلغ آخر حركة",
  colLastJournal: "رقم آخر قيد",
  colLastReference: "مرجع آخر حركة",
  colDays: "عدد الأيام",
  colMovements: "عدد الحركات",
  colTotalDebit: "إجمالي المدين",
  colTotalCredit: "إجمالي الدائن",
  colOpening: "الرصيد الافتتاحي",
  colBalance: "الرصيد",
  colBalanceType: "نوع الرصيد",
  colBalanceAge: "عمر الرصيد (يوم)",
  colAbnormal: "رصيد غير طبيعي",
  colStatus: "حالة الحساب",
  colZeroBalance: "صفر رصيد",
  colDormant: "راكد",
  colDormancyReason: "سبب الركود",
  colNeedsReview: "يحتاج مراجعة",
  colAction: "الإجراء المقترح",
  colAgeFlag: "تصنيف العمر",
  colSector: "القطاع",
  colSubsector: "القطاع الفرعي",
  colProvince: "المحافظة",
  colGroup: "المجموعة",
  colAccountCreatedAt: "تاريخ إنشاء الحساب",
  colAlert: "التنبيه",
  colCondition: "الشرط",
  colAlertAction: "الإجراء",
  colValue: "القيمة",
  yes: "نعم",
  no: "لا",
  details: "التفاصيل",
  noAlerts: "لا توجد تنبيهات",
  noDeleted: "لا توجد حسابات لأطراف محذوفة",
  deletedNote: "حسابات الأطراف المحذوفة لا تدخل في الجدول التفصيلي ولا في الملخص.",
  truncated: "عدد الحسابات يتجاوز 10,000 - يرجى تضييق التصفية",
  sheetHeader: "رأس التقرير",
  sheetDetailed: "تفصيلي",
  sheetSummary: "ملخص",
  sheetAlerts: "تنبيهات",
  headerSector: "القطاع",
  headerSubsector: "القطاع الفرعي",
  headerAccounts: "عدد الحسابات",
  headerYearStart: "بداية السنة المالية",
  headerThresholds: "حدود التصنيف (يوم)",
  headerWarnings: "تحذيرات",
  headerNotes: "ملاحظات",
  field: "البند",
  value: "القيمة",
  printSummary: "ملخص التقرير حسب القطاع",
  printDetailed: "الجدول التفصيلي",
  printAlerts: "التنبيهات",
  rangeNeedsBounds: "أدخل حدي الرصيد للنطاق المحدد",
  statusLabels: {
    active: "نشط",
    semi_active: "شبه نشط",
    dormant: "راكد",
    very_dormant: "راكد جداً",
    unused: "غير مستخدم",
    closed: "مُغلق",
    zero_balance: "صفر رصيد",
  },
  actionLabels: {
    correct_balance: "تصحيح الرصيد",
    close: "إغلاق الحساب",
    urgent_review: "مراجعة عاجلة",
    alert: "تنبيه",
    normal: "متابعة عادية",
    none: "لا إجراء",
  },
  partyTypeLabels: {
    captain: "سائق",
    center: "مركز شحن",
    business: "منشأة",
    owner: "مالك سيارة",
    employee: "موظف",
  },
  partyStatusLabels: {
    active: "نشط",
    suspended: "موقوف",
    deleted: "محذوف",
  },
  sideLabels: {
    debit: "مدين",
    credit: "دائن",
    balanced: "متوازن",
  },
  ageFlags: {
    new: "جديد",
    dead: "ميت",
  },
};
